class AppConstants {
  public static readonly APP_TITLE: string = 'Why at Work';

  public static readonly OFFICEMANAGER_ROLE: string = 'officemanager';

  public static readonly ADMIN_ROLE: string = 'administrator';

  public static readonly WHYELLOW_ROLE: string = 'whyellow';

  public static readonly MINIMUM_DESKTOP_WIDTH: number = 980;

  public static readonly MAXIMUM_QR_AMOUNT: number = 1000;

  public static readonly TOOLTIP_GENERAL_ID: string = 'tooltip-general';

  public static readonly NAVIGATION_COLLAPSED_STORAGE_KEY: string = 'whyatwork_navigation_collapsed';
}

export default AppConstants;
